import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import { buildUrl } from '~/features/shared/search/coordinate/builder/buildUrl'
import { Base } from './Base'

type Props = {
  brands: Schemas.brand[]
}

export const FavoriteBrand: React.FC<Props> = ({ brands }) => {
  return (
    <Base title="よく着用するブランド">
      {brands.map((brand) => {
        if (!brand?.key) return
        return (
          <li key={brand.id}>
            <Chip
              href={buildUrl({
                snapItems: [
                  { brand: { id: brand.id, key: brand.key, name: brand.name } },
                ],
              })}
            >
              {brand.name}
            </Chip>
          </li>
        )
      })}
    </Base>
  )
}
